import React from "react";
import {
  Routes,
  Route
} from "react-router-dom";

import Home from "@/app/pages/home";
import LandingPage from "@/app/pages/businessDirectory/LandingPage";
import SiteSearchPage from "@/app/pages/businessDirectory/SiteSearchPage";
import CompanyProfile from "@/app/pages/companyProfile";
import ContactDirectory from "@/app/pages/contactDirectory";
import DynamicCommonRoutesComponent from "@/app/router/DynamicCommonRoutesComponent";
import PageNotFound from "@/app/pages/pageNotFound";
import DunsOptoutToolComponent from "@/app/pages/dunsOptOut/DunsOptoutToolComponent";

import {
  businessDirectoryLandingPageRoutes,
  siteSearchResultPageRoutes,
  companyProfilePageRoutes,
  upikPageRoutes
} from "@/app/router/routes"; 
import { businessDirecProps } from "@/testData/businessDirectory"
import { usePageURL } from "@/shared/customHooks";
import { getSiteSearchResultPagePath } from "@/utils"
import OptoutContacts from "@/app/pages/utilityPages";
import { UpikContainer } from "@/app/pages/upik/components/Container";
import OptOutLogs from "../pages/utilityPages/OptOutLogs/OptOutLogs";
import OptOutContactsReport from "../pages/utilityPages/OptOutLogs/OptOutContactsReport";

const AppRouter = (): JSX.Element => {
  const { countryCode, languageCode, currentPageUrl } = usePageURL();

  const businessDirectoryProps = {
    ...businessDirecProps,
    languageCode,
    countryCode,
    singlePageSearchData: {
      ...businessDirecProps.singlePageSearchData,
      currentPagePath: currentPageUrl,
      // siteSearchPath: "/content/dnb-de/de/startseite/seitensuche",
      // siteSearchPathRewritten: "/de-de/seitensuche.html",
      siteSearchResultsPath: getSiteSearchResultPagePath(countryCode).siteSearchResultsPath,
      siteSearchResultsPathRewritten: getSiteSearchResultPagePath(countryCode).siteSearchResultsPathRewritten
    }
  }

  // in the below routes we append  '.html'  because
  // we have to show the same behavoiur as AEM application behaves

  const siteSearchPageProps = {
    ...businessDirectoryProps,
    isSearchOverlay: false,
    resourcePath: "/content/dnb-de/de/startseite/seitensuche-ergebnisse/jcr:content/content-ipar-cta/singlepagesearch"
  }


  return (
    <Routes>
      <Route path="/" element={<Home />} />
      {businessDirectoryLandingPageRoutes.map(path =>
        <Route
          path={path}
          element={<LandingPage {...businessDirectoryProps} />}
          key={path}
        />
      )}
      {siteSearchResultPageRoutes.map(path =>
        <Route
          path={path}
          element={<SiteSearchPage {...siteSearchPageProps} />}
          key={path}
        />
      )}
      {companyProfilePageRoutes.map(path =>
        <Route
          path={`${path}/:companyHash`}
          element={<CompanyProfile countryCode={countryCode} languageCode={languageCode} />}
          key={path}
        />
      )}
      {upikPageRoutes.map(path =>
        <Route
          path={path}
          element={<UpikContainer currentPagePath={currentPageUrl} hereRedirectionLinkUrl={""} />}
          key={path}
        />
      )}      
      <Route
        path="/business-directory/:companyHash"
        element={<DynamicCommonRoutesComponent countryCode={countryCode} languageCode={languageCode} />}
      />
      <Route path="/business-directory/:industryPage" element={<DynamicCommonRoutesComponent />} />
      <Route path="/business-directory/:companyInformation" element={<DynamicCommonRoutesComponent />} />

      <Route path="/contact-directory.html" element={<ContactDirectory {...businessDirectoryProps} />} />
      <Route path="/contact-directory/:contactProfileHash" element={<DynamicCommonRoutesComponent />} />
      <Route path="/contact-directory/:contactIndustryHash" element={<DynamicCommonRoutesComponent />} />
      <Route path="/utility-pages/suppressduns.html" element={<DunsOptoutToolComponent/>} />
      <Route path="/utility-pages/optout-contacts.html" element={<OptoutContacts />} />
      <Route path="/utility-pages/opt-out-logs.html" element={<OptOutLogs />} />
      <Route path="/utility-pages/optout-contacts-report.html" element={<OptOutContactsReport />} />
      <Route path="*" element={<PageNotFound countryCode={countryCode} />} />
    </Routes>
  )
}

export default AppRouter;
